import { cnvTimestampToDateStr, cnvTimestampToDHMS } from "@/utils/datetime-utils";
import Moment from "react-moment";
import { useState, useEffect, useContext } from "react";
import PoolContext from "@/seed/contexts/pool/pool-context";
import commonConstant from "@/constants/commonConstant";
import moment from "moment-timezone";

const CountDown = ({
    from,
    to,
    introLb,
    displayFromTo = false,
    tba = false,
    onTimeCallBack,
}) => {
    // ⚠️ getTime() is called on every render
    //  const [currentTime, setCurrentTime] = useState( new Date().getTime());
    // ✅ getTime() is only called once
    const [currentTime, setCurrentTime] = useState(() => new Date().getTime());

    const [hasCountdown, setHasCountdown] = useState(false);

    const { refreshToNext } = useContext(PoolContext);

    useEffect(() => {
        let counter = setTimeout(() => {
            // Check valid to create timer: prevent infinite loop
            if (!tba && !isNaN(to)) {
                const now = new Date().getTime();

                if (now <= to) {
                    if (!hasCountdown) setHasCountdown(true);
                    setCurrentTime(now);
                } else {
                    clearTimeout(counter);
                    // Check has timer: prevent infinite loop
                    if (hasCountdown && refreshToNext) {
                        onTimeCallBack ? onTimeCallBack() : () => {};
                        refreshToNext();
                    }
                }
            }
        }, 1000);
        return () => {
            if (counter) clearTimeout(counter);
        };
    }, [currentTime, to]);

    const executeCountDown = () => {};

    const duration = to - currentTime;

    const dhms = cnvTimestampToDHMS(duration > 0 ? duration : 0);
    const data = [
        {
            title: "Days",
            value: dhms.days,
        },
        {
            title: "Hours",
            value: dhms.hours,
        },
        {
            title: "Minutes",
            value: dhms.minutes,
        },
        {
            title: "Seconds",
            value: dhms.seconds,
        },
    ];
    const renderIntroLb = () => {
        if (introLb) {
            return <span className="font-secondary text-sm md:text-lg">{introLb}</span>;
        }
    };
    const renderCountDown = () => {
        if (tba) {
            return <span className="font-primary text-3xl md:text-7xl">TBA</span>;
        } else {
            return (
                <div className="flex flex-row font-primary">
                    {data.map((e, index) => (
                        <div
                            key={index.toString()}
                            className={
                                index < data.length - 1
                                    ? "flex flex-col text-primary flex items-center px-5 space-y-4 w-20 md:w-40 border-solid border-r-[1px] border-white"
                                    : "flex flex-col text-primary flex items-center px-5 space-y-4 w-20 md:w-40"
                            }
                        >
                            <span className="text-3xl md:text-6xl">{e.value}</span>
                            <span className="text-xs md:text-xl">{e.title}</span>
                        </div>
                    ))}
                </div>
            );
        }
    };
    const renderFromToStr = () => {
        if (displayFromTo) {
            return (
                <div
                    className={
                        "flex flex-col md:flex-row justify-center items-center font-secondary text-sm md:text-lg md:space-x-5"
                    }
                >
                    <span>
                        From <Moment format={commonConstant.FORMAT_DATE_TIMEZONE} date={from} />
                    </span>
                    <span className="hidden md:block"> - </span>
                    <span>
                        To <Moment format={commonConstant.FORMAT_DATE_TIMEZONE} date={to} />
                    </span>
                </div>
            );
        }
        return null;
    };
    return (
        <div className="flex flex-col items-center space-y-[7%]">
            {renderIntroLb()}
            {renderCountDown()}
            {renderFromToStr()}
        </div>
    );
};

export default CountDown;
